




import { defineComponent, computed } from '@nuxtjs/composition-api'
import { useProductStore } from '~/store/product'

import LegalStatement from '@/components/feature/PDP/LegalStatement.vue'
import { useCMSGlobalSettingsStore } from '~/store'

export default defineComponent({
  components: { LegalStatement },
  setup() {
    const { getStatements, currentProduct } = useProductStore()
    const { getAttributeByCountry } = useCMSGlobalSettingsStore()
    const trademarks = getStatements(currentProduct.data.key, 'trademark')
    const legals = getStatements(currentProduct.data.key, 'legal')
    const legalStatementRteNode = computed(() => getAttributeByCountry('legalStatement'))

    return { trademarks, legals, legalStatementRteNode }
  },
})
